import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { useScreenSize } from '../../hooks/useScreenSize';
import { SanityArticleCategory, SanityCategoryGroup } from '../../types/common';
import { GlassIcon, XIcon } from '../Icons';
import InternalLink from '../InternalLink';
import { LogoPeanut } from './LogoPeanut';

type AdvancedFilterProps = {
  groups: SanityCategoryGroup[];
  categories: SanityArticleCategory[];
  filteredCategories: string[];
  filteredGroups: string[];
  onFilter: (categoryId: string) => void;
  onFilterGroup: (groupKey: string) => void;
  onClearFilters: () => void;
  isFilterOpen?: boolean;
  onCloseFilter?: () => void;
}

export function AdvancedFilter({ groups, categories, filteredCategories, filteredGroups, onFilter, onClearFilters, isFilterOpen, onCloseFilter, onFilterGroup }: AdvancedFilterProps) {
  const { isMobile } = useScreenSize();

  const queryResponse = useStaticQuery(graphql`
  query ArticlesCategories {
    sanitySearchPage {
      slug {
        current
      }
    }
  }
`);

  const CategoryList = categories.map(category => (
    <button
      key={category._id}
      onClick={() => onFilter(category._id)}
      className={`filter-tag ${filteredCategories.includes(category._id) && 'active'}`}
    >
      <XIcon size={16} />
      {category.name}
    </button>
  ));

  return (
    <aside className='filters'>
      {!isMobile && (
        <div>
          <h3>Filters</h3>
          {(filteredCategories.length > 0 || filteredGroups.length > 0) && (
            <button className='clear' onClick={onClearFilters}>Clear all filters</button>
          )}
        </div>
      )}

      <div>
        {groups.map(group => (
          <button
            key={group._key}
            onClick={() => onFilterGroup(group._key)}
            className={`tag-button ${filteredGroups.includes(group._key) && 'active'}`}
          >
            {group.groupName}
            <span />
          </button>
        ))}
      </div>
      <p>Filter the information {isMobile && 'below '}using these tags</p>

      {!isMobile && (
        <>
          <div className='advanced-tags-desktop'>
            {CategoryList}
          </div>
          <div className='media-desktop'>
            <h4>For media inquiries</h4>
            <a href='mailto:media@nationalpeanutboard.org'>media@nationalpeanutboard.org</a>
          </div>
        </>
      )}


      {isMobile && (
        <div className={`advanced-tags ${isFilterOpen ? 'open' : ''}`}>
          <div className='advanced-tags-header'>
            <button onClick={onCloseFilter}>
              <XIcon />
            </button>
            <LogoPeanut />
            <InternalLink reference={queryResponse.sanitySearchPage}>
              <GlassIcon />
            </InternalLink>
          </div>
          <h2>Filters</h2>
          <div className='advanced-tags-list'>
            {CategoryList}
          </div>
        </div>
      )}
    </aside>
  );
}
